// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"301":"4b79b43b","608":"b5b2f8cc","731":"74084954","787":"a3c7353c","808":"b8966142"}[chunkId] + ".chunk.js";
};